/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q2_BInputs */

const en_consult_q2_b = /** @type {(inputs: Consult_Q2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$1,000 – $3,000`)
};

const id_consult_q2_b = /** @type {(inputs: Consult_Q2_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp10–30 juta`)
};

/**
* | output |
* | --- |
* | "$1,000 – $3,000" |
*
* @param {Consult_Q2_BInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q2_b = /** @type {((inputs?: Consult_Q2_BInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q2_BInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q2_b(inputs)
	return en_consult_q2_b(inputs)
});